import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import * as React from 'react';
import './datepicker.css';
import { Divider, FormHelperText, Grid, Popover } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
import CustomTextField from './CustomTextField';
import CustomButton from './CustomButton';


export default function CustomYearRangePicker({ setStartYear, setEndYear, value, open, close, isOpen, startYear, endYear, error }) {
    const [menu, setMenu] = React.useState(null);
    const [currentStartYear, setCurrentStartYear] = React.useState(startYear);
    const [currentEndYear, setCurrentEndYear] = React.useState(endYear);

    React.useEffect(() => {
        if(startYear !== currentStartYear || endYear !== currentEndYear) {
            setCurrentStartYear(startYear);
            setCurrentEndYear(endYear);
        }
    }, [startYear, endYear]);

    const openPopoverHandle = React.useCallback((event) => {
        setMenu(event.currentTarget);
    }, []);
    const closePopover = React.useCallback(() => {
        setMenu(null);
    }, []);

    const handleClearAll = () => {
        setCurrentEndYear('');
        setCurrentStartYear('');
    }

    const handleApply = () => {
        setStartYear(currentStartYear);
        setEndYear(currentEndYear);
        closePopover();
    }

    return (
        <>

            <div className="d-flex align-items-center year-range-container" style={{color: startYear ? 'black' : '#c4c4c4' }} onClick={openPopoverHandle}>
                <div className='d-flex justify-content-between align-items-center w-100'>
                    <div className='' style={{color: startYear || endYear ? '#101010': '#999999'}}>{startYear || endYear ? `${startYear} ${endYear ? `- ${endYear}` : ''}` : 'Year'}</div> <i className="ri-arrow-down-s-line"></i>
                </div>
            </div>
            <Popover
                sx={{
                    "& .MuiPaper-root": {
                        boxShadow: "0 2px 4px rgba(16, 16, 16, 0.08)",
                        borderRadius: "12px"
                    }
                }}
                open={!!menu}
                anchorEl={menu}
                onClose={closePopover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <div style={{ width: 430, padding: 20 }}>
                    <div className="d-flex justify-content-between mb-4">
                        <div className="text-bold font-size-16">Year</div>
                        <div className="clickable" style={{ textDecoration: 'underline' }} onClick={() => { handleClearAll() }}>Clear all</div>
                    </div>
                    <Grid container spacing={2}>
                        <Grid item sm={6}>
                            <CustomTextField
                                title={'From'}
                                type={'number'}
                                placeholder={'0'}
                                values={currentStartYear}
                                showTitle={true}
                                onChange={(val) => setCurrentStartYear(val)}
                                paddingBlock={"10px"}
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <CustomTextField
                                title={'End'}
                                type={'number'}
                                placeholder={'0'}
                                showTitle={true}
                                values={currentEndYear}
                                onChange={(val) => setCurrentEndYear(val)}
                                paddingBlock={"10px"}
                            />
                        </Grid>
                    </Grid>
                    <div className="p-2 d-flex justify-content-center pt-3" style={{ backgroundColor: 'white' }}>
                        <CustomButton
                            title={'Apply'}
                            press={() => { handleApply() }}
                            padding={20}
                            width={'100%'}
                        />
                    </div>
                </div>
            </Popover>

            {error && <FormHelperText sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={16} width={16} />{error || ""}</FormHelperText>}
        </>
    );
}
